import React from 'react';
import { Dialog, Slide, withStyles } from 'material-ui';
import DialogStyles from './SeatSelectionDialogStyles';
import SeatSelectionMobileContainer from './SeatSelectionMobileContainer';
import SeatSelectionDialogProps from './SeatSelectionDialogProps';

function Transition (props) {
  return <Slide direction='down' {...props} />;
}

const SeatSelectionDialog = ({
  editOpened,
  handleClose,
  classes,
  selectedPassenger,
  showDate,
  routes,
  selectedTrip,
  selectedRoute,
  toggleRoutes,
  centered,
}) => (
  <div className='edit-passenger-dialog'>
    <Dialog
      fullScreen
      open={editOpened}
      onClose={handleClose}
      transition={Transition}
      classes={classes}
    >
      <SeatSelectionMobileContainer
        handleClose={handleClose}
        selectedPassenger={selectedPassenger}
        centered={centered}
        showDate={showDate}
        routes={routes}
        selectedTrip={selectedTrip}
        selectedRoute={selectedRoute}
        toggleRoutes={toggleRoutes}
      />
    </Dialog>
  </div>
);

SeatSelectionDialog.propTypes = SeatSelectionDialogProps;

export default withStyles(DialogStyles)(SeatSelectionDialog);



// WEBPACK FOOTER //
// ./src/containers/seats/mobile/SeatSelectionDialog.js